import { GET_NOTIFICATIONS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_NOTIFICATIONS:
            return action.payload;
        default:
            return state;
    }
}